import { combineReducers } from 'redux';
import Inquiry from './r.inquiry-form'

const appReducer = combineReducers({
    Inquiry
})

const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        console.log("reset");
        state = undefined;
    }
    return appReducer(state, action);
}

export default rootReducer;